var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 0.5C4.17969 0.5 4.57031 0.851562 4.64844 1.28125L4.72656 1.75H21.1328C21.9531 1.75 22.5781 2.57031 22.3438 3.35156L20.2344 10.8516C20.0781 11.3984 19.6094 11.75 19.0234 11.75H6.64062L6.99219 13.625H19.0625C19.5703 13.625 20 14.0547 20 14.5625C20 15.1094 19.5703 15.5 19.0625 15.5H6.21094C5.78125 15.5 5.39062 15.1875 5.3125 14.7578L2.96875 2.375H0.9375C0.390625 2.375 0 1.98438 0 1.4375C0 0.929688 0.390625 0.5 0.9375 0.5H3.75ZM18.5547 9.875L20.3125 3.625H5.11719L6.28906 9.875H18.5547ZM5 18.625C5 17.6094 5.82031 16.75 6.875 16.75C7.89062 16.75 8.75 17.6094 8.75 18.625C8.75 19.6797 7.89062 20.5 6.875 20.5C5.82031 20.5 5 19.6797 5 18.625ZM20 18.625C20 19.6797 19.1406 20.5 18.125 20.5C17.0703 20.5 16.25 19.6797 16.25 18.625C16.25 17.6094 17.0703 16.75 18.125 16.75C19.1406 16.75 20 17.6094 20 18.625Z",
    fill: "#464B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCart);
export default __webpack_public_path__ + "static/media/AddToCart.93de23827a76673b4a70bebd6a1dd415.svg";
export { ForwardRef as ReactComponent };